import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { addressFormSchema } from './address-form.schema'

export const useAddressForm = () => {
  return useForm({
    resolver: yupResolver(addressFormSchema),
    defaultValues: addressFormSchema.cast({}),
  })
}
